import { atom, useRecoilState } from 'recoil'

import { IBypass } from './use-bypass'

const filtersState = atom<{verbatim: string | null, state: string[]}>({
  key: 'BypassFilters',
  default: {
    verbatim: null,
    state: []
  }
})

const selection = atom<IBypass[]>({
  key: 'BypassIdsSelected',
  default: []
})

const sortState = atom({
  key: 'BypassSort',
  default: {
    by: 'created_at',
    direction: 'desc'
  }
})

export const useSelection = () => {
  return useRecoilState(selection)
}

export const useSort = ():  [{ direction: string; by: string }, (sort: string) => void] => {
  const [{ direction, by }, setSort] = useRecoilState<{direction: string, by: string}>(sortState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}

export const useFilters = () => {
  return useRecoilState(filtersState)
}